import { createSlice } from '@reduxjs/toolkit';

import { HighRiskSupplement } from '@models/highRiskSupplement';

import { handleSearchHighRiskSupplements } from '../highRiskSupplementsSearch/actions';

import { handleGetHighRiskSupplementsList } from './actions';
import { IHighRiskSupplementsState } from './slice.interface';

const initialState: IHighRiskSupplementsState = {
  data: null,
  searchData: null,
  isLoading: false,
  error: false,
  pagination: { page: 1 },
};

export const highRiskSupplementsSlice = createSlice({
  name: 'high-risk-supplements',
  initialState,
  reducers: {
    removeHighRiskSupplementsSearchData: state => {
      state.searchData = null;
    },
    removeHighRiskSupplementsList: state => {
      state.data = null;
      state.isLoading = false;
      state.error = false;
      state.pagination = {
        page: 1,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetHighRiskSupplementsList.pending,
        (state: IHighRiskSupplementsState, action) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetHighRiskSupplementsList.rejected,
        (state: IHighRiskSupplementsState, action) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetHighRiskSupplementsList.fulfilled,
        (state: IHighRiskSupplementsState, action) => {
          state.isLoading = false;
          state.data = Array.isArray(action?.payload?.data?.tableData)
            ? action.payload.data.tableData.map(item => new HighRiskSupplement(item))
            : null;
          state.pagination = action.payload.data.pagination;
        },
      )
      .addCase(
        handleSearchHighRiskSupplements.fulfilled,
        (state: IHighRiskSupplementsState, action) => {
          state.isLoading = false;
          const { page, pageCount } = action.payload.data.pagination;
          const normalizedData = Array.isArray(action?.payload?.data?.tableData)
            ? action.payload.data.tableData.map(item => new HighRiskSupplement(item))
            : [];
          if (pageCount === 1 || page === 1) {
            state.searchData = {
              ...action.payload.data,
              tableData: normalizedData,
            };
          } else {
            state.searchData = {
              ...action.payload.data,
              tableData: [...(state.searchData?.tableData ?? []), ...normalizedData],
            };
          }
        },
      );
  },
});

export const { removeHighRiskSupplementsList, removeHighRiskSupplementsSearchData } =
  highRiskSupplementsSlice.actions;

export default highRiskSupplementsSlice.reducer;
